import React, { useState, useEffect } from 'react';
import './MaintenancePage.css';

const MaintenancePage = () => {
  const [dots, setDots] = useState('');

  // Animated dots effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="maintenance-container">
      {/* Background animation */}
      <div className="background-animation">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      {/* Content */}
      <div className="maintenance-content">
        {/* Logo/Icon */}
        <div className="maintenance-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"></path>
            <path d="M12 6v6l4 2"></path>
          </svg>
        </div>

        {/* Main heading */}
        <h1 className="maintenance-title">
          We'll Be Back Soon
        </h1>

        {/* Description */}
        <p className="maintenance-description">
          We're currently performing scheduled maintenance to bring you a better experience.
        </p>

        {/* Loading animation */}
        <div className="loading-animation">
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
        </div>

        {/* Status text */}
        <p className="status-text">
          Working{dots}
        </p>

        {/* Contact info */}
        <div className="contact-info">
          <p>If you have any urgent questions, feel free to reach us at:</p>
          <a href="mailto:promisevisa.in@gmail.com" className="contact-link">
            promisevisa.in@gmail.com
          </a>
        </div>

        {/* Footer */}
        <footer className="maintenance-footer">
          <p>&copy; 2026 LEEANNZ HR solutions. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default MaintenancePage;
